module.exports = __webpack_public_path__ + "static/media/logo-instagram.c1dbcbd5.svg";